module.exports = __webpack_public_path__ + "static/img/arr_mo.2763ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010109/arr_mo.png
// module id = 7NvM
// module chunks = 10